import { BehaviorSubject } from 'rxjs';
var DocumentIssueFormService = (function () {
    function DocumentIssueFormService() {
        this.selectedProducts = new BehaviorSubject(null);
    }
    return DocumentIssueFormService;
}());
export { DocumentIssueFormService };



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/document-issue-form/document-issue-form.service.ts.pre-build-optimizer.js